var _excluded = ["scaleId"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { ALL_MOTIVATOR_ICONS } from "./index";
var AltruismFilled = ALL_MOTIVATOR_ICONS.AltruismFilled,
  AutonomyFilled = ALL_MOTIVATOR_ICONS.AutonomyFilled,
  CompetitionFilled = ALL_MOTIVATOR_ICONS.CompetitionFilled,
  FeedbackFilled = ALL_MOTIVATOR_ICONS.FeedbackFilled,
  FinancialNeedsFilled = ALL_MOTIVATOR_ICONS.FinancialNeedsFilled,
  InnovationFilled = ALL_MOTIVATOR_ICONS.InnovationFilled,
  ProgressFilled = ALL_MOTIVATOR_ICONS.ProgressFilled,
  RationalityFilled = ALL_MOTIVATOR_ICONS.RationalityFilled,
  SocialRelationshipsFilled = ALL_MOTIVATOR_ICONS.SocialRelationshipsFilled,
  StatusFilled = ALL_MOTIVATOR_ICONS.StatusFilled,
  SecurityFilled = ALL_MOTIVATOR_ICONS.SecurityFilled;

// Should be imported from its own file to avoid circular references to `MotivatorIcons/index.js`

export function MotivatorIcon(_ref) {
  var scaleId = _ref.scaleId,
    opts = _objectWithoutProperties(_ref, _excluded);
  return {
    1: /*#__PURE__*/React.createElement(SecurityFilled, opts),
    2: /*#__PURE__*/React.createElement(StatusFilled, opts),
    3: /*#__PURE__*/React.createElement(SocialRelationshipsFilled, opts),
    4: /*#__PURE__*/React.createElement(CompetitionFilled, opts),
    5: /*#__PURE__*/React.createElement(RationalityFilled, opts),
    6: /*#__PURE__*/React.createElement(ProgressFilled, opts),
    7: /*#__PURE__*/React.createElement(FeedbackFilled, opts),
    8: /*#__PURE__*/React.createElement(InnovationFilled, opts),
    9: /*#__PURE__*/React.createElement(AltruismFilled, opts),
    10: /*#__PURE__*/React.createElement(FinancialNeedsFilled, opts),
    11: /*#__PURE__*/React.createElement(AutonomyFilled, opts)
  }[scaleId] || null;
}